
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import venta from './estadisticas-articulos-venta-articulos.vue';
    import buscador from './estadisticas-articulos-buscador.vue';
    import { EstadisticaVentas } from '@/__env/lib/Articulos';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            venta,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Estado: string = 'cargando';
        public CargandoMas: boolean = false;

        public Buscando: boolean = false;
        public Items: EstadisticaVentas[] = [];

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            let e = await EstadisticaVentas.actuales( { page: this.Pagina } );
            this.Items = e.Items;
            console.log( this.Items.length );
            this.Estado = 'ok';
        }


        protected Pagina = 1;
        async CargarMas()
        {
            this.CargandoMas = true;
            this.Pagina += 1;
            let e = await EstadisticaVentas.actuales( { page: this.Pagina } );
            this.Items.push( ...e.Items );
            this.CargandoMas = false;
        }


    }
